import { ApiRequestConfig, ZhuliTypes } from '../../../../api';

export const getAirAstanaInstructionsList: ApiRequestConfig<
  unknown,
  unknown,
  ZhuliTypes['CatalogDtoLong'][]
> = () => ({
  method: 'GET',
  url: '/api/zhuli/air-astana/instruction-docs/list',
});
